// extracted by mini-css-extract-plugin
export default {"stepper":"register_stepper__yCbZm"};